import { skillPaths } from '../data/learningContent';
import { useDocumentMeta } from '../lib/useDocumentMeta';
import PathCard from '../components/PathCard';

export default function SkillPathsPage() {
  useDocumentMeta({
    title: 'Skill Paths — AI Practice Paths | PromptGPT',
    description: 'Practice paths that train specific AI skills through daily challenges. Each path targets one skill area with graded exercises. Start anywhere, progress at your own pace.',
    canonical: 'https://promptgpt.ai/skill-paths',
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name: 'PromptGPT Skill Paths',
      description: 'Practice paths that train specific AI skills through daily challenges.',
      url: 'https://promptgpt.ai/skill-paths',
    },
  });
  return (
    <div className="container-app py-12 max-w-5xl">
      <div className="max-w-2xl mb-12">
        <div className="text-[11px] uppercase tracking-[0.22em] font-semibold text-ink-500 mb-3">
          Paths
        </div>
        <h1 className="font-display text-4xl sm:text-5xl mb-3">Pick a path that fits where you are.</h1>
        <p className="text-ink-600 text-lg leading-relaxed">
          Every path is a series of challenges targeting one skill area. Same shape, different depth.
          Start anywhere.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {skillPaths.map((p) => {
          const lessonCount = p.modules.reduce((a, m) => a + m.lessons.length, 0);
          return (
            <PathCard
              key={p.slug}
              to={`/skill-paths/${p.slug}`}
              title={p.title}
              objective={p.description}
              glyph={p.glyph}
              lessonCount={lessonCount}
              proOnly={p.proOnly}
            />
          );
        })}
      </div>
    </div>
  );
}
